module.exports = __webpack_public_path__ + "media/src/assets/Images/MaintenanceIcon-35693f55f19e5d3a44b47e81e2f43f5d.svg";